import React from 'react';
import { graphql } from 'gatsby';

// This block is not being used and will be removed.
const Quicklinks: React.FC<Queries.QuicklinksDataFragment> = () => null;
export const query = graphql`
  fragment QuicklinksData on CsQuicklinks {
    ... on CsQuicklinks {
      heading
      links {
        href
        title
      }
    }
  }
`;

export default Quicklinks;
